var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgResultSparkle = function SvgResultSparkle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.667,
    height: 14.667,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.667 14.667"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#result-sparkle_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF1B0",
    d: "M7.333 4c.2 1.867 1.467 3.133 3.334 3.333-1.867.2-3.134 1.467-3.334 3.334C7.133 8.8 5.867 7.533 4 7.333 5.867 7.133 7.133 5.867 7.333 4"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgResultSparkle;